import { render } from "./PriceTrackChart.vue?vue&type=template&id=791a1470&ts=true"
import script from "./PriceTrackChart.vue?vue&type=script&lang=ts"
export * from "./PriceTrackChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__